import React from 'react';
import { NavLink } from 'react-router-dom';
import '../assets/styles/components/MenuInternal.sass';

const MenuBogota = () => (
  <div className="row MenuInternal --bogota">
    <div className="container">
      <div className="row">
        <div className="col-12">
          <ul className="MenuInternal__list">
            <li className="MenuInternal__list--item">
              <NavLink to="/volcano-mtb/tour-overview">
                RESUMEN
              </NavLink>
            </li>
            <li className="MenuInternal__list--item">
              <NavLink to="/volcano-mtb/itinerary/start">
                ITINERARIO
              </NavLink>
            </li>
            <li className="MenuInternal__list--item">
              <NavLink to="/volcano-mtb/package-and-price">
                PAQUETES Y PRECIO
              </NavLink>
            </li>
            <li className="MenuInternal__list--item">
              <NavLink to="/volcano-mtb/upgrades-and-prices">
                ASCENSOS Y PRECIOS
              </NavLink>
            </li>
            <li className="MenuInternal__list--item">
              <NavLink to="/volcano-mtb/hotels">
                HOTELES
              </NavLink>
            </li>
            <li className="MenuInternal__list--item">
              <NavLink to="/volcano-mtb/travel-details">
                DETALLES DEL VIAJE
              </NavLink>
            </li>
            <li className="MenuInternal__list--item">
              <NavLink to="/volcano-mtb/important-info">
                INFORMACIÓN IMPORTANTE
              </NavLink>
            </li>
            <li className="MenuInternal__list--item">
              <NavLink to="/booknow/volcano-mtb">
                RESERVAR AHORA
              </NavLink>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
)
  
export default MenuBogota;